import { FC, useMemo, useState, useEffect, useRef } from "react"
import { KTSVG } from "../../../../../_metronic/helpers"
import { cloneDeep, remove } from "lodash"

type Props = {
  title: string
  labelCodes: Array<string>
  targetLabels: Array<string> | null
  doClose: Function
  doSubmit: Function
  subTitle?: string
  labelSeries?: number
}

const DLMLabelSelectorModal: FC<Props> = ({title, subTitle, labelCodes, targetLabels, doClose, doSubmit, labelSeries = -1}) => {

  const [selected, setSelected] = useState<Array<string>>([]);
  const [labelFilter, setLabelFilter]  = useState('');

  const availableSelectRef = useRef<HTMLSelectElement>(null);

  const { available, available_cnt } = useMemo(() => {

    if (! (labelCodes && labelCodes.length > 0)) {
      return { available: [], available_cnt: 0} ;
    }

    let _available: Array<string> = [];

    labelCodes.forEach( strval => {
      if (! (selected.indexOf(strval) > -1)) {
        _available.push(strval);
      }
    })

    _available.sort();

    const available_cnt: number = _available.length;

    if (available_cnt && labelFilter && labelFilter.length > 0) {
      const patt = new RegExp(labelFilter, 'i');
      remove(_available, code => (! patt.test(code)));
    }

    return { available: _available, available_cnt};

  }, [labelCodes, labelFilter, selected]);


  const addSelected = () => {
    if (! (availableSelectRef.current && availableSelectRef.current.options)) return;

    let _selected = cloneDeep(selected);
    Object.values(availableSelectRef.current.options).forEach( opt => {
      if (opt.selected) {
        _selected.push(opt.value);
      }
    });
    _selected.sort();
    setSelected(_selected);
  }

  const removeSelected = (e: any) => {
    const elem = e.target.closest('.tagBtn');
    if (elem) {
      let _selected = cloneDeep(selected);
      _selected.splice(parseInt(elem.dataset.idx), 1);
      setSelected(_selected);
    }
  }

  useEffect(() => {
    if (! (targetLabels && targetLabels.length > 0)) {
      return;
    }
    let _labels = targetLabels;
    _labels.sort();
    setSelected(_labels);
  }, [targetLabels]);

  return (
    <>
    <div
      className='modal fade show d-block'
      id='kt_dlm_label_selector_modal'
      role='dialog'
      tabIndex={-1}
      aria-modal='true'
    >
      <div className='modal-dialog modal-dialog-centered mw-550px'>
        <div className='modal-content'>
          <div className='modal-header pt-4 pb-1'>
            <div>
              <h2 className='fw-bolder'>{title}</h2>
              {subTitle &&
                <span className='text-muted fs-6'>{subTitle}</span>
              }
            </div>
            <div
              className='btn btn-icon btn-sm btn-active-icon-primary'
              data-kt-roi-select-multiple-labels-modal-action='close'
              onClick={()=> { doClose()}}
              style={{cursor: 'pointer'}}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
            </div>
          </div>

          <div className='modal-body scroll-y mx-1 mb-4 pe-3'>
            <div className="row">
              <div className="col-4">
              <div className="fs-7">
                { (labelFilter && labelFilter.length > 0)  ? (
                  <span>{`${available.length} / ${available_cnt} found.`}</span>
                ) : (
                  <span>{`${available_cnt} available.`}</span>
                )}
              </div>
              <div className="d-flex flex-row align-items-center gap-2">
                <div>
                  <select
                    ref={availableSelectRef}
                    className='form-select form-select-solid fw-bold mb-2 fs-7'
                    size={11}
                    multiple={true}
                    onDoubleClick={(e : any) => {
                      if (! ( e.target?.dataset && e.target.dataset?.code)) return;
                      e.stopPropagation();
                      let _selected = cloneDeep(selected);
                      _selected.push(e.target.dataset.code);
                      _selected.sort();
                      setSelected(_selected);
                    }}
                  >
                    {available.map( _code => (
                        <option
                          key={`available${_code}`} value={_code} data-code={_code}
                          className="mb-1"
                        >
                          {_code}
                        </option>
                    ))}
                  </select>
                  <div>
                    <label className="text-muted fs-7">Filter</label>
                    <input
                      name="labelFilter"
                      value={labelFilter}
                      className="form-control form-control-solid form-control-sm"
                      onChange={(e:any) => {
                        setLabelFilter(e.target.value.trim());
                      }}
                    />
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-light text-success btn-active-success px-2 pb-2 pt-1 ms-2"
                  onClick={addSelected}
                  title="Add Selected Labels"
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr017.svg' className='svg-icon m-0 line-height-0' />
                </button>
              </div>

            </div>
            <div className="col-8">
              <div className="fs-7">
                {`${selected.length} selected.`}
              </div>
              <div className='d-flex flex-wrap gap-2 align-content-start form-control p-1 h-200px overflow-auto'>
              {(selected && selected.length > 0) &&
              selected.map( (val: string, idx: number) => (
                <div
                  key={`tagBtn${idx}`}
                  className="tagBtn btn btn-sm btn-light text-dark btn-active-warning ps-3 pe-0 py-1 h-25px"
                  data-idx={idx}
                >
                  {val}
                  <div
                    className="badge badge-sm badge-square text-hover-danger ps-2"
                    title="Remove"
                    onClick={removeSelected}
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr011.svg' className='svg-icon' />
                  </div>
                </div>
              ))}
              </div>
            </div>
          </div>

          <div className='text-center mt-6'>
            <button
              type='button'
              onClick={()=> { doClose()}}
              className='btn btn-light me-3'
              data-kt-roi-select-label-modal-action='cancel'
            >
              Cancel
            </button>

            <button
              type='button'
              className='btn btn-primary'
              data-kt-roi-select-label-modal-action='submit'
              onClick={()=> {
                doSubmit(selected, labelSeries)
              }}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  </>
  )
}

export { DLMLabelSelectorModal}